import { CirclePlay } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { TCarouselItem } from '../loginRightSection';

type CarouselSlideProps = {
  item: TCarouselItem;
  onWatchNow?: () => void;
};

export const CarouselItem: React.FC<CarouselSlideProps> = ({
  item,
  onWatchNow,
}) => {
  return (
    <div className='embla__slide flex-[0_0_100%]'>
      <div className='description flex flex-col justify-center'>
        {item.type === 'video' && onWatchNow && (
          <Button
            size='lg'
            variant='dark'
            className='mx-auto mb-10 inline-flex min-h-[42px] gap-2 rounded-full bg-[rgba(255,255,255,0.2)] py-2 text-lg font-semibold'
            onClick={onWatchNow}
          >
            <CirclePlay /> Watch Now
          </Button>
        )}
        <div className='content mx-auto max-w-[638px] text-center text-2xl font-bold text-white'>
          {item.description}
        </div>
      </div>
    </div>
  );
};
